let routers = []

const getAllRouters = (array) => {
	array.forEach(f => {
		if(f.children){
			getAllRouters(f.children)
		}else{
			let {path, filePath} = f
			routers.push({
				name: path,
				path: path,
				component: () => import(`@/pages/${filePath || path}.vue`),
				meta: {
					path: `${path}`,
					auth: true
				}
			})
		}
	})
}

const routersArray = array => {
	getAllRouters(array)
	return routers
}

export default {
	routersArray
}

